<template>
  <div class="PresentPersonel">
    <present-personel-section-search-panel @search="search" />
    <box class="mt-2" :title="$t('presentList')">
      <template slot="top-action-view">
        <v-icon
          v-if="list.length >= 0 && visiblePrint"
          @click="print"
          color="white"
          >mdi-printer</v-icon
        >
      </template>
      <div class="vacationList">
        <div v-if="list.length > 0">
          <present-personel-list-web
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClick="onClick"
          />
          <present-personel-list-mob
            @onClick="onClick"
            :list="list"
            class="hidden-md-and-up"
          />
        </div>
        <div v-else>
          <empty-list />
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import PresentPersonelListMob from "../../components/personelOperationReport/presentPersonelList/PresentPersonelListMob.vue";
import PresentPersonelListWeb from "../../components/personelOperationReport/presentPersonelList/PresentPersonelListWeb.vue";
import PresentPersonelSectionSearchPanel from "../../components/personelOperationReport/PresentPersonelSectionSearchPanel.vue";
import EmptyList from "../../components/widget/EmptyList.vue";
import ResultType from "../../model/ResultType";
import EosUtils from "../../utils/EosUtils";
export default {
  components: {
    PresentPersonelListWeb,
    PresentPersonelListMob,
    EmptyList,
    PresentPersonelSectionSearchPanel,
  },
  data() {
    return {
      list: [],
      visiblePrint: false,
      sectionCode: "",
    };
  },
  methods: {
    search(searchParams) {
      var params = searchParams;
      this.sectionCode = params.sectionCode;
      /*if (params.sectionCode == "0" || params.sectionCode == "" || params.sectionCode == "-1") {
        params.sectionCode = '';
      }*/

      this.$store.dispatch("GetPresentPersonel", { params }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.list = result.data;
          this.checkVisiblePrint();
        }
      });
    },
    async checkVisiblePrint() {
      var IsFreeOfGroupManager = false;
      await this.$store.dispatch("IsFreeOfGroupManager").then((result) => {
        if (result.type === ResultType.success) {
          IsFreeOfGroupManager = result.data;
        }
      });

      if (!EosUtils.isWebKartAdmin() && !IsFreeOfGroupManager) {
        var adminPermissionList =
          this.$store.state.personel.personelDetail.AdminPermission.Table;
        adminPermissionList.every((element) => {
          var adminPermission = element.adminPermission;
          console.log(adminPermission[50]);
          if (adminPermission && adminPermission[50].toString() == "1") {
            this.visiblePrint = true;
            return false;
          }
          return true;
        });
      } else {
        this.visiblePrint = true;
      }
    },
    print() {
      let routeData = this.$router.resolve({
        name: "rpPeresentPersonel",
        query: { SC: this.sectionCode },
      });
      window.open(routeData.href, "_blank");
    },
    onClick() {},
  },
};
</script>

<style>
</style>